import { Component, inject, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-modal-duplicate-query',
  templateUrl: './modal-duplicate-query.component.html',
  imports: [MatDialogModule, MatButtonModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, TranslocoPipe],
})
export class ModalDuplicateQueryComponent implements OnInit {
  dialogRef = inject(MatDialogRef<ModalDuplicateQueryComponent>);
  data = inject<{ name: string }>(MAT_DIALOG_DATA);

  nameControl = new FormControl('', [Validators.required, Validators.maxLength(255)]);

  ngOnInit(): void {
    this.nameControl.setValue(`CLONE - ${this.data.name}`);
  }

  confirm(): void {
    if (this.nameControl.valid) {
      this.dialogRef.close(this.nameControl.value);
    }
  }
}
